import { UPDATE_CURRENT, PREVSONG, NEXTSONG } from "../constants/action_types";

const currentalbum_handler = (data = {
  albums: [],
  album: {
    songs: [],
    cover: ""
  },
  song_index: 0
}, action) =>
{
  let tempstore = { ...data };

  switch (action.type)
  {
    case UPDATE_CURRENT:
      tempstore.album = action.payload.current_albums[action.payload.album_index];
      tempstore.song_index = action.payload.song_index;
      navigator.mediaSession.metadata.artwork = [
        { src: tempstore.album.cover, sizes: "96x96", type: "image/png" },
        { src: tempstore.album.cover, sizes: "128x128", type: "image/png" },
        { src: tempstore.album.cover, sizes: "192x192", type: "image/png" },
        { src: tempstore.album.cover, sizes: "256x256", type: "image/png" },
        { src: tempstore.album.cover, sizes: "384x384", type: "image/png" },
        { src: tempstore.album.cover, sizes: "512x512", type: "image/png" },
      ];
      return tempstore;
    case PREVSONG:
      if (tempstore.song_index === 0)
      {
        tempstore.song_index = tempstore.album.songs.length - 1;
      }
      else
      {
        tempstore.song_index--;
      }
      return tempstore;
    case NEXTSONG:
      tempstore.song_index = (tempstore.song_index + 1) % tempstore.album.songs.length;
      return tempstore;
    default:
      return tempstore;
  }
}

export default currentalbum_handler;